import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OfferStatusEnum} from "@app/enums/offer-status.enum";
import {ModalContainerComponent} from "@app/modal/modal-container/modal-container.component";
import {PersonalOfferInterface, RedistributionRequestInterface} from "@app/redistribution/redistribution.interface";
import {NgIf} from "@angular/common";
import {
  RedistributionStatusComponent
} from "@app/redistribution/shared/redistribution-status/redistribution-status.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {catchError, throwError} from "rxjs";
import {ToastService} from "@app/toast/toast.service";

@Component({
  selector: 'app-modal-reject-personal-proposal',
  templateUrl: './modal-reject-personal-proposal.component.html',
  styleUrls: ['./modal-reject-personal-proposal.component.scss'],
  standalone: true,
  imports: [
    ModalContainerComponent,
    NgIf,
    RedistributionStatusComponent,
    ReactiveFormsModule,
    LoadingAnimationComponent
  ]
})
export class ModalRejectPersonalProposalComponent implements OnInit {
  isLoading = false;
  
  @Input() redistributionRequest!: RedistributionRequestInterface;
  @Input() personalOffer!: PersonalOfferInterface;
  @Output() updateData = new EventEmitter<void>();
  
  @ViewChild('modalContainer') modalContainer!: ModalContainerComponent;
  
  constructor(
      private redistributionApiService: RedistributionApiService,
      private toastService: ToastService,
  ) { }
  
  ngOnInit(): void {
    
    // setTimeout(() => {
    //   this.modalContainer.openModal()
    // }, 1000);
  }
  
  open() {
    this.modalContainer.openModal()
    this.isLoading = false;
  }
  
  close() {}
  
  save() {
    this.isLoading = true;
    
    this.redistributionApiService.rejectPersonalProposal(this.personalOffer.id)
        .pipe(
            catchError((error) => {
              this.toastService.showError(error.error.messages[1]);
              this.isLoading = false;
              return throwError(() => error);
            })
        )
        .subscribe(() => {
          this.toastService.showSuccess('Запис успішно відхилино')
          this.isLoading = false;
          this.updateData.emit();
          this.modalContainer.close();
        })
  }
  
  cancel() {
    this.modalContainer.close();
  }

}
